import axios from '@/utils/axios'
// 添加追剧列表
export function listVideoMedia(query) {
    return axios({
        url: '/video/info/getList',
        method: 'get',
        params: query
    })
}
// 详情
export function details(query) {
    return axios({
        url: '/video/info/details',
        method: 'get',
        params: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/video/info/delete',
        method: 'get',
        params: query
    })
}
// 添加追剧
export function addVideoMedia(query) {
    return axios({
        url: '/video/info/addInfo',
        method: 'post',
        data: query
    })
}
// 获取标签
export function listLabel(query) {
    return axios({
        url: '/lable/getList',
        method: 'get',
        params: query
    })
}
// 一键上传vid
export function addVid(query) {
    return axios({
        url: '/video/info/addVid',
        method: 'get',
        params: query
    })
}
// 一键上传视频
export function addVideo(query) {
    return axios({
        url: '/video/info/addVideo',
        method: 'get',
        params: query
    })
}
// 编辑短剧
export function addEpisodeId(query) {
    return axios({
        url: '/video/info/addEpisodeId',
        method: 'get',
        params: query
    })
}
// 短剧授权
export function addVideoAuth(query) {
    return axios({
        url: '/video/info/addVideoAuth',
        method: 'get',
        params: query
    })
}
// 送审查询
export function submitReview(query) {
    return axios({
        url: '/video/info/submitReview',
        method: 'get',
        params: query
    })
}
// 创建短剧
export function createVideo(query) {
    return axios({
        url: '/video/info/createVideo',
        method: 'get',
        params: query
    })
}
// 审核查询
export function getVerifyStatus(query) {
    return axios({
        url: '/video/info/getVerifyStatus',
        method: 'get',
        params: query
    })
}
// 上线或下线
export function upOrDownVideo(query) {
    return axios({
        url: '/video/info/upOrDownVideo',
        method: 'get',
        params: query
    })
}


// let ruleFormData = this.ruleForm
// let videoRecordData = this.ruleForm.videoRecord
// let videoInfoVo = {
//     updateType: ruleFormData.updateType,
//     appid: ruleFormData.appid,
//     appidName: ruleFormData.appidName,
//     videoUpdateStatus: ruleFormData.videoUpdateStatus,
//     id: ruleFormData.id,
//     introduce: ruleFormData.introduce,
//     issueYear: ruleFormData.issueYear,
//     labelInfo: ruleFormData.labelInfo.toString(),
//     picId: ruleFormData.picId,
//     picUrl: ruleFormData.picUrl,
//     qualifiedStatus: ruleFormData.qualifiedStatus,
//     recommendDescribe: ruleFormData.recommendDescribe,
//     sumEps: ruleFormData.sumEps,
//     title: ruleFormData.title,
//     verifyNumber: ruleFormData.verifyNumber,
//     videoAbility: ruleFormData.videoAbility,
//     videoRecord: {
//         contentOutline: videoRecordData.contentOutline,
//         costPicId: videoRecordData.costPicId,
//         costPicUrl: videoRecordData.costPicUrl,
//         director: this.directorList.toString(),
//         dramatist: this.dramatistList.toString(),
//         duration: videoRecordData.duration,
//         costType: videoRecordData.costType,
//         generalRecordNo: videoRecordData.generalRecordNo,
//         id: videoRecordData.id,
//         importantRecordNo: videoRecordData.importantRecordNo,
//         licenseKey: videoRecordData.licenseKey,
//         organization: videoRecordData.organization,
//         performer: this.performerList.toString(),
//         producer: this.producerList.toString(),
//         promisePicId: videoRecordData.promisePicId,
//         promisePicUrl: videoRecordData.promisePicUrl,
//         recordType: videoRecordData.recordType,
//         registerNo: videoRecordData.registerNo,
//         sumEps: videoRecordData.sumEps,
//         svName: videoRecordData.svName,
//         svaRecordNo: videoRecordData.svaRecordNo,
//     }
// }